import { render, staticRenderFns } from "./ProductTile.vue?vue&type=template&id=7575c7f8&scoped=true&lang=pug"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"
import style0 from "./ProductTile.vue?vue&type=style&index=0&id=7575c7f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7575c7f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7575c7f8')) {
      api.createRecord('7575c7f8', component.options)
    } else {
      api.reload('7575c7f8', component.options)
    }
    module.hot.accept("./ProductTile.vue?vue&type=template&id=7575c7f8&scoped=true&lang=pug", function () {
      api.rerender('7575c7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductTile.vue"
export default component.exports